"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_component_library_1 = require("@onegov/react-component-library");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_use_1 = require("react-use");
var WizardStepContext_1 = require("./WizardStepContext");
var core_1 = require("../core");
var WizardPage = function (_a) {
    var stepId = _a.stepId, children = _a.children;
    (0, react_component_library_1.useScrollToTopOnMount)();
    var step = core_1.WizardStepRegistry.getStepById(stepId);
    var isStepValid = (0, react_1.useMemo)(function () { return !!(step === null || step === void 0 ? void 0 : step.isValid()); }, [step]);
    var history = (0, react_router_dom_1.useHistory)();
    (0, react_use_1.useMount)(function () {
        if (!isStepValid) {
            var logicalStep = core_1.WizardStepRegistry.getFirstIncompleteStep(step);
            var stepUrl = logicalStep === null || logicalStep === void 0 ? void 0 : logicalStep.getUrl();
            stepUrl && history.replace(stepUrl);
        }
    });
    if (!isStepValid)
        return null;
    return ((0, jsx_runtime_1.jsx)(WizardStepContext_1.WizardStepContextProvider, __assign({ stepId: stepId, step: step }, { children: children })));
};
exports.WizardPage = WizardPage;
//# sourceMappingURL=WizardPage.js.map